import React, { useEffect, useId, useRef, useState } from 'react';

/**
 * Field help (?) with a styled popover (primary border), instead of native title tooltip.
 */
const FieldHelpIcon = ({ help }) => {
  const tooltipId = useId();
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  if (!help || !String(help).trim()) {
    return null;
  }

  return (
    <span
      ref={rootRef}
      className={`field-help${open ? ' is-open' : ''}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="field-help-trigger"
        aria-label={help}
        aria-describedby={open ? tooltipId : undefined}
        aria-expanded={open}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen((prev) => !prev);
        }}
        onFocus={() => setOpen(true)}
        onBlur={(event) => {
          if (!rootRef.current?.contains(event.relatedTarget)) {
            setOpen(false);
          }
        }}
      >
        <i className="fa fa-question-circle field-help-icon" aria-hidden="true" />
      </button>
      {open && (
        <span id={tooltipId} className="field-help-popover" role="tooltip">
          {help}
        </span>
      )}
    </span>
  );
};

export default FieldHelpIcon;
